import React from 'react'
import PropTypes from 'prop-types'

import Countdown from 'artkive/components/VirtualGalleryCountdownBox/Countdown'
import VirtualGalleryPrice from 'artkive/components/VirtualGalleryPrice'
import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useResponsive from 'artkive/hooks/useResponsive'
import routes from 'artkive/utils/routes'

import {
  AdditionalText,
  ButtonWrapper,
  CountdownWrapper,
  DescriptionText,
  DescriptionWrapper,
  Image,
  InfoBox,
  StyledTrackButton,
  TextBox,
  TitleText,
  Wrapper,
} from './VirtualGalleryCountdownBox.style'

const VirtualGalleryCountdownBox = ({
  withImage,
  withFreePrice,
  title,
  description = 'with purchase of Artkive Box and Kids Art Book',
  buttonLabel = 'Get My Box',
  buttonHref = routes.boxCheckout,
  additionalText = 'Limited Time Offer!',
  imageUrl = null,
}) => {
  const { isMobile } = useResponsive()

  const countdownElement = (
    <CountdownWrapper withImage={withImage}>
      <Countdown />
    </CountdownWrapper>
  )

  return (
    <Wrapper withImage={withImage}>
      {withImage && <Image imageUrl={imageUrl} />}
      <DescriptionWrapper withImage={withImage}>
        <InfoBox withImage={withImage}>
          <TextBox withImage={withImage}>
            {countdownElement}
            {withImage && isMobile && <AdditionalText>{additionalText}</AdditionalText>}
            {!!title && (
              <>
                {typeof title === 'string' ? (
                  <TitleText variant='h4' withImage={withImage}>
                    {title}
                  </TitleText>
                ) : (
                  title
                )}
              </>
            )}
            <DescriptionText variant='body1'>{description}</DescriptionText>
          </TextBox>
          {withFreePrice && <VirtualGalleryPrice />}
        </InfoBox>
        <ButtonWrapper>
          <StyledTrackButton
            withImage={withImage}
            color='primary'
            size='large'
            variant='contained'
            href={buttonHref}
            trackerEvent={GET_BOX_CLICK}
            trackerOptions={{
              section: 'virtual_gallery_countdown_box',
            }}
          >
            {buttonLabel}
          </StyledTrackButton>
        </ButtonWrapper>
      </DescriptionWrapper>
    </Wrapper>
  )
}

VirtualGalleryCountdownBox.propTypes = {
  withImage: PropTypes.bool,
  withFreePrice: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  description: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonHref: PropTypes.string,
  additionalText: PropTypes.string,
  imageUrl: PropTypes.string,
}

export default VirtualGalleryCountdownBox
